import { api } from './api'

const getListApp = data =>
    new Promise((resolve, reject) => {
        api
            .get(`/api/v1/shop/deliveryApp?shopCode=${data}`)
            .then(response => {
                const resData = response.data

                if (resData.result_code === '00000') {
                    data = { shop_code: data, ...resData }
                    resolve(data)
                } else {
                    reject({ code: resData.result_code, message: resData.result_msg })
                }
            })
            .catch(error => {
                reject(error?.message)
            })
    })

const updateApps = data =>
    new Promise((resolve, reject) => {
        api
            .patch(`/api/v1/shop/deliveryApp`,data)
            .then(response => {
                const resData = response.data

                if (resData.result_code === '00000') {
                    data = { ...resData }
                    resolve(data)
                } else {
                    reject({ code: resData.result_code, message: resData.result_msg })
                }
            })
            .catch(error => {
                reject(error?.message)
            })
    })
const deliveryAppConfig = { getListApp,updateApps }

export { deliveryAppConfig }